import { KycSettingsView } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/components/KycSettingsView';
import { ProgrammeDefaultsEmptyState } from '@dealstack/frontend/app/pages/Organization/OrganizationProgrammeDefaults/components/ProgrammeDefaultsEmptyState';
import { useOrganizationRequirements } from '@dealstack/frontend/app/pages/Organization/OrganizationProgrammeDefaults/hooks/useOrganizationRequirements';

interface Props {
	organizationId: string;
	canEdit: boolean;
}

export const ProgrammeDefaultsKycSettings = ({ organizationId, canEdit }: Props) => {
	const { isConfigured, startFromDefaults, ...kycSettings } = useOrganizationRequirements({
		organizationId,
		canEdit,
	});

	if (kycSettings.isLoading) {
		return null;
	}

	if (!isConfigured) {
		return <ProgrammeDefaultsEmptyState canEdit={canEdit} onStart={startFromDefaults} />;
	}

	return <KycSettingsView kycSettings={kycSettings} organizationId={organizationId} />;
};
